<template>
  <img
    v-auto-title
    v-bind="$attrs"
    :src="props.src || '/images/default_image.svg'"
    @error="onError"
  />
</template>

<script setup lang="ts">
// @ts-ignore
const props = defineProps<{
  src: string | null;
}>();

// @ts-ignore
function onError(event: Event) {
  const target = event.target as HTMLImageElement;
  target.src = "/images/default_image.svg";
}
</script>
